
  async function loadWasm(retries = 2, delayMs = 800) {
    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        const { default: init, encrypt_json } = await import(
          "https://minio.handy10nam.online/acecook/assets/wasm.js"
        );
        await init();
        window.encryptJson = (jsonStr) => {
          try {
            if (jsonStr.length < 128) return encrypt_json(jsonStr);
            return "";
          } catch {
            return "";
          }
        };
        window.dispatchEvent(new Event("wasm-ready"));
        return;
      } catch (err) {
        if (attempt === retries) {
          console.error("[wasm] init failed after retries", err);
          window.dispatchEvent(
            new CustomEvent("wasm-error", {
              detail: `${err?.message ?? err} (after ${attempt + 1} attempts)`,
            })
          );
          return;
        }
        await new Promise((r) => setTimeout(r, delayMs * (attempt + 1)));
      }
    }
  }
  loadWasm();
